import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useSelection } from '@providers/SelectionProvider'

const ReorderButton: React.FC = () => {
  const { t } = useTranslation()
  const {
    actions: { setSorting },
  } = useSelection()

  return (
    <Button
      variant="outline"
      size="sm"
      className="font-medium ml-2.5 hidden sm:inline-flex"
      onClick={() => setSorting(true)}>
      {t('action.reorder')}
    </Button>
  )
}

export default ReorderButton
